var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarCheck01 = function SvgCalendarCheck01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.95 17.688-3.204-3.204 1.085-1.085 2.119 2.12 4.22-4.22 1.084 1.085zM4.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T4.308 3.5h1.384V1.385h1.539V3.5h9.577V1.385h1.5V3.5h1.384q.758 0 1.283.525t.525 1.283v14.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V9.308H4v10.384q0 .116.096.212a.3.3 0 0 0 .212.096M4 7.808h16v-2.5a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212z"
  })));
};
export default SvgCalendarCheck01;